import React, { useState } from "react";
import { ArrowPathIcon } from '@heroicons/react/24/solid';
import { loadClusterState } from '../../store/cluster/actions';
import { useDispatch } from "react-redux";
import IconButton from "../../components/IconButton";

const RefreshState = () => {
    const dispatch = useDispatch();
    const [isRotating, setIsRotating] = useState(false);
    
    const handleClick = () => {
        if (isRotating) return; // Prevent multiple clicks during rotation
        
        setIsRotating(true);
        dispatch(loadClusterState());
        
        // Reset rotation state after animation completes
        setTimeout(() => {
            setIsRotating(false);
        }, 500); // Match the duration of the rotation animation
    };

    const getButtonClasses = () => {
        let baseClasses = "border-primary text-primary bg-gray-50 hover:bg-gray-100";
        
        if (isRotating) {
            baseClasses += " [&>svg]:animate-spin [&>svg]:duration-500";
        }
        
        return baseClasses;
    };

    return (
        <div className="flex justify-center items-center">
            <IconButton
                variant="outline"
                size="icon"
                rounded="full"
                Icon={ArrowPathIcon}
                onClick={handleClick}
                disabled={isRotating}
                className={getButtonClasses()}
            />
        </div>
    );
};

export default RefreshState;